import React, { useEffect, useState, useRef, useContext } from 'react'


export const ForgotPasswordConfirmStep = (props) => {

    const handleFormSubmit = (e) => {
        e.preventDefault();
        window.location = '/'
    }

    return (
        <div>
            <form noValidate className="floify-login-form confirm-step" id="forgot-password-form" onSubmit={ (e) => handleFormSubmit(e) }>
                <div className="login-inner-padded">
                    <h1 className="h3" id="modal-title">Check Your Email</h1>
                </div>
                <div className="login-popup-form">
                    <div className="login-inner-padded flex justify-space-between">
                        <img src={ require(`../assets/images/icons/email-verify.svg`) } alt="Verify Email Icon" />
                        <p>We’ve sent you an email. Follow the instructions included in the message to reset your password. </p>
                    </div>
                    <div className="login-modal-footer">
                        <div className="modal-buttons-container login-inner-padded flex justify-space-between align-items-center">
                            <div className="login-button-wrapper">
                                <button id="login-next-btn" name="Next" className="lp-button buttonHover" type="submit" onClick={ (e) => handleFormSubmit(e) }>Back to Log In</button>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}